$mol_icon_stop $mol_icon path \M18,18H6V6H18V18Z
